import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import {
  Alert,
  Box,
  Button,
  FormControl,
  Modal,
  Snackbar,
  TextField,
  Typography,
  Card,
  InputAdornment
} from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { UpdateDriverDetails } from '../../../network/Trip';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: '#FFFFFF'
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

const useStyles = makeStyles({
  customDashCard: {
    background: '#FFFFFF',
    boxShadow: '10px 10px 19px 1px #EAEAFF',
    borderRadius: '20px',
    minHeight: '190px'
  }
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  minWidth: { xs: '60%', sm: '350px' },
  // border: '1px solid #000',
  // boxShadow: 24,
  p: 4,
  borderRadius: 1
  // maxWidth: '30%'
};

const updateDriverDetailSchema = Yup.object().shape({
  driverName: Yup.string().required('Required'),
  driverMobile: Yup.string()
    .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
    .required('Required')
});

export default function UpdateDriverOnTrip({
  openAssignedModal,
  driverData,
  handleClose,
  onAction
}) {
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  const updateDriverDetailFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      driverName: driverData?.driver_name || '',
      driverMobile: driverData?.driver_phone || ''
    },
    validationSchema: updateDriverDetailSchema,
    onSubmit: (values, { resetForm }) => {
      updateDriver(values?.driverName, values?.driverMobile);
    }
  });
  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = updateDriverDetailFormik;

  const updateDriver = async (name, mobile) => {
    const payload = {
      name,
      mobile
    };
    try {
      const res = await UpdateDriverDetails(driverData?.id, payload);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: 'Driver updated successfully !'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      }
      onAction();
      handleClose();
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    } finally {
      updateDriverDetailFormik.setSubmitting(false);
      handleClose();
    }
  };

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Modal
        open={openAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="edit-driver-modal"
      >
        <FormikProvider value={updateDriverDetailFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 900 }}>
                Update Driver Details
              </Typography>

              <FormControl fullWidth sx={{ mt: 3 }}>
                <TextField
                  id="driverName"
                  label={
                    <Typography
                      sx={{
                        fontSize: {
                          xs: '12px',
                          sm: '14px'
                        },
                        fontWeight: 500
                      }}
                    >
                      Driver Name
                    </Typography>
                  }
                  variant="outlined"
                  name="driverName"
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      fontSize: { xs: '12px', sm: '14px' },
                      padding: { xs: '14px 8px', sm: '16.5px' }
                    }
                  }}
                  {...getFieldProps('driverName')}
                  error={Boolean(touched.driverName && errors.driverName)}
                  helperText={touched.driverName && errors.driverName}
                />
              </FormControl>

              <FormControl fullWidth sx={{ mb: 3, mt: 3 }}>
                <TextField
                  id="driverMobile"
                  name="driverMobile"
                  label={
                    <Typography
                      sx={{
                        fontSize: {
                          xs: '12px',
                          sm: '14px'
                        },
                        fontWeight: 500
                      }}
                    >
                      Driver Mobile No
                    </Typography>
                  }
                  type="number"
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      fontSize: { xs: '12px', sm: '14px' },
                      padding: { xs: '14px 2px', sm: '16.5px' }
                    }
                  }}
                  {...getFieldProps('driverMobile')}
                  error={Boolean(touched.driverMobile && errors.driverMobile)}
                  helperText={touched.driverMobile && errors.driverMobile}
                  InputProps={{
                    maxLength: 2,
                    startAdornment: (
                      <InputAdornment position="start">
                        <Button
                          variant="text"
                          size="small"
                          sx={{
                            fontSize: { xs: '12px', sm: '14px' },
                            padding: { xs: '0px 4px', sm: '2px 6px' },
                            minWidth: 'unset',
                            height: '20px',
                            lineHeight: 1
                          }}
                        >
                          +91
                        </Button>
                      </InputAdornment>
                    ),
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                  }}
                />
              </FormControl>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                <Button variant="outlined" size="small" onClick={handleClose}>
                  Cancel
                </Button>
                <LoadingButton
                  variant="contained"
                  size="small"
                  type="submit"
                  sx={{ textWrap: 'nowrap' }}
                  loading={isSubmitting}
                >
                  Save Changes
                </LoadingButton>
              </Box>
            </Box>
          </Form>
        </FormikProvider>
      </Modal>
    </Box>
  );
}
